var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');
require('../../components/window-height');
require('../../components/google-search-autocomplete');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$newFilterModal', [
    '$log',
    '$uibModal',
    '$timeout',

    function $newFilterModalService($log, $uibModal, $timeout) {
        /*
        @function openFirstFilterModal
        */
        return function openNewFilterModal() {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: ['$scope', function newFilterModalCtrl($scope) {

                    $scope.submitKeyword = function () {
                        if($scope.keyword && $scope.keyword.length > 0) {
                            $scope.$close({
                                keyword: $scope.keyword,
                                latLng: $scope.latLng
                            });
                        }else {
                            $scope.$close();
                        }
                    };

                    var init = function () {};

                    init();
                }],
                keyboard: false,
                backdrop: 'static',
                windowClass: 'new-filter-modal'
            });

            return modal.result;
        };
    }
]);
